import { graphql } from '@/gql';
import type { GenerateDriverAcceptedSmsExampleQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const generateDriverAcceptedSmsExample = async (input: GenerateDriverAcceptedSmsExampleQueryVariables): Promise<string> => {
  const response = await queryExecute({
    query: graphql(`
      query GenerateDriverAcceptedSmsExample(
        $callerId: String!
        $serviceType: String!
        $customRiderName: String!
        $isEmergency: Boolean!
        $noteToDriver: String
        $riderNote: String
        $driverNotePickUp: String
        $driverNoteDropOff: String
        $lowTipAmount: Float
        $highTipAmount: Float
        $isMultiStop: Boolean
        $pickupLocationName: String!
        $pickupLocationAddress: String!
        $startLat: Float
        $startLong: Float
        $rideType: String
      ) {
        generateDriverAcceptedSmsExample(
          callerId: $callerId
          serviceType: $serviceType
          customRiderName: $customRiderName
          isEmergency: $isEmergency
          noteToDriver: $noteToDriver
          riderNote: $riderNote
          driverNotePickUp: $driverNotePickUp
          driverNoteDropOff: $driverNoteDropOff
          lowTipAmount: $lowTipAmount
          highTipAmount: $highTipAmount
          isMultiStop: $isMultiStop
          pickupLocationName: $pickupLocationName
          pickupLocationAddress: $pickupLocationAddress
          startLat: $startLat
          startLong: $startLong
          rideType: $rideType
        )
      }
    `),
    variables: {
      ...input,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.generateDriverAcceptedSmsExample;
};
